import { colors } from "@/styles/colors"
import { makeStyles } from "@material-ui/core"
import { themeColors } from "letalkui"

const useStyles = makeStyles((theme) => ({
	boardCard: {
		marginTop: theme.spacing(1),
		paddingLeft: theme.spacing(3),
		paddingRight: theme.spacing(3),
		paddingBottom: theme.spacing(1)
	},
	boardContent: {
		paddingBottom: theme.spacing(1),
		paddingTop: theme.spacing(1)
	},
	contactValueSectionContainer: {
		marginTop: theme.spacing(1.5)
	},
	contactValueContainer: {
		padding: theme.spacing(1, 1.5),
		borderRadius: 8,
		backgroundColor: themeColors.colors.system.green[50]
	},
	contactValueClickable: {
		cursor: "pointer"
	},
	contactValueText: {
		fontSize: "14px",
		fontWeight: 600,
		color: themeColors.colors.success[800]
	},
	contactValueEditIcon: {
		fontSize: "18px",
		color: themeColors.colors.success[800]
	},
	contactValueEmptyChip: {
		width: "100%",
		padding: theme.spacing(0.5, 1.5),
		borderRadius: 8,
		border: `1px dashed ${themeColors.colors.system.gray[300]}`
	},
	contactValueEmptyChipIcon: {
		fontSize: "16px",
		color: themeColors.colors.system.gray[600],
		marginRight: theme.spacing(0.5)
	},
	contactValueEmptyChipText: {
		fontSize: "13px",
		fontWeight: 500,
		color: themeColors.colors.system.gray[600]
	},
	removeContactFromBoardContainer: {
		marginTop: theme.spacing(2)
	},
	removeContactFromBoardText: {
		cursor: "pointer",
		display: "flex",
		alignItems: "center",
		gap: "8px",
		color: colors.gray[900]
	},
	removeContactFromBoardIcon: {
		width: "18px",
		height: "18px",
		aspectRatio: "1 / 1",
		color: colors.gray[900]
	},
	selectInput: {
		"& .MuiOutlinedInput-input": {
			padding: "var(--400, 16px)"
		}
	},
	wonStageIcon: {
		fontSize: 20,
		marginRight: 8,
		color: themeColors.colors.success[700]
	},
	lostStageIcon: {
		fontSize: 20,
		marginRight: 8,
		color: themeColors.colors.error[700]
	},
	defaultStageIcon: {
		fontSize: 20,
		marginRight: 8
	}
}))

export default useStyles
